import React, { Component } from 'react';
import { translate } from 'react-polyglot';
import classNames from 'classnames';
import Checkbox from '../Checkbox';
import StemCard from '../StemCard';
import BookShelf from '../BookShelf';
import BookCard from '../BookCard';
import Grid from '../Grid';
import { gaReadSource } from '../../lib/constants';
import '../OfflineGradeCard/OfflineGradeCard.scss';
import Button from '../Button';
@translate()
class OfflineStemCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isButtonClicked: props.open,
    }
  }

  onToggleButton = () => {
    this.setState({ isButtonClicked: !this.state.isButtonClicked })
  }

  render() {
    const baseClassName = 'pb-offline-grade-card';
    const {
      t,
      stemBooks,
      editActive,
      onChange,
      stemCheckedValues,
      isRtl,
      viewport,
      online,
    } = this.props;

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--edit-active`]: editActive,
      [`${baseClassName}--edit-active-checked`]: stemBooks && stemBooks.length > 0 ? stemCheckedValues.map(el=>parseInt(el, 10)).includes(stemBooks[0].lpId) : null,
      [`${baseClassName}--is-button-clicked`]: this.state.isButtonClicked && !editActive,
      [`${baseClassName}--rtl`]: isRtl,
    };

    return (
      stemBooks && stemBooks.length > 0 &&
      <div className={classNames(classes)}>
        {
          editActive ?
            <div className={`${baseClassName}__checkbox-wrapper`}>
              <Checkbox
                id={stemBooks[0].lpId}
                activeIcon={"active"}
                inactiveIcon={"inactive"}
                value={stemBooks[0].lpId}
                inline
                onChange={onChange}
                checked={stemCheckedValues.map(el=>parseInt(el, 10)).includes(stemBooks[0].lpId)}
                theme="white"
                themeLabel="white"
                themeCardLabel
              /></div>
            :
            null
        }
          <div className={`${baseClassName}__card`}>
            <div>
            <StemCard lessonPlan={stemBooks[0].lpData} t={t} isFromStemOffline stemLang={stemBooks[0].locale} isRtl={isRtl}/>
            </div>
            <div className={`${baseClassName}__card-desc`}>
            <div className={`${baseClassName}__card-title`}>{stemBooks[0].learnings}</div>
              <ul className={`${baseClassName}__card-list`}>
              {stemBooks[0].lpData.attributes.learnings.length > 0 && stemBooks[0].lpData.attributes.learnings.map(el=><li>{el.point}</li>)}
              </ul>
              <Button
                iconRight={"down-arrow"}
                label={t("global.view-books").toLowerCase()}
                parentClassName={!this.state.isButtonClicked || editActive ? `${baseClassName}__svg`: `${baseClassName}__svg ${baseClassName}__svg-reverse`}
                onClick={() => this.onToggleButton()}
                variant="offline"
                rounded
                noIconTitle
                isRtl={isRtl}
              />
            </div>
          </div>
          {
            this.state.isButtonClicked && !editActive
              ?
              <div className={`${baseClassName}__stem-book-grid`}>
                {viewport.medium ?
                  <BookShelf
                    viewport={viewport}
                    books={stemBooks}
                    popoutControls={true}
                    readSource={"stem"}
                    isOfflineStem={true}
                    eventLabel={'stem'}
                    eventCategory={gaReadSource.offlineLibrary}
                    />
                  :
                  <Grid variant="2up-6up" isRtl={isRtl}>
                    {stemBooks.map(book => {
                      return (
                        <BookCard
                          key={book.id}
                          id={book.id}
                          book={book}
                          shouldDisplayMenu={true}
                          customMenu = {true}
                          hideQuickViewBtn={true}
                          shouldShowReadIcon={true}
                          noSrcSet={!online}
                          hideReadCountStat={true}
                          readSource={gaReadSource.stem}
                          eventLabel={'stem'}
                          isRtl={isRtl}
                          eventCategory={gaReadSource.offlineLibrary}
                          />
                      );
                    })}
                  </Grid>}
                </div>
              : null
          }
      </div>
    )
  }
}

export default OfflineStemCard;


// WEBPACK FOOTER //
// ./src/components/OfflineStemCard/OfflineStemCard.jsx